import { ImportError } from './ImportError'

/**
 * Error that is thrown when a import value is required.
 */
export class ImportValueRequiredError extends ImportError {
  constructor(message: string) {
    super(message)
    this.name = 'ImportValueRequiredError'
    Object.setPrototypeOf(this, new.target.prototype)
  }
}
